// extracted by mini-css-extract-plugin
export default {"container":"SectionTitleLeftWaves_container__iCB5Y","title":"SectionTitleLeftWaves_title__L-f8a","leftWavesIcon":"SectionTitleLeftWaves_leftWavesIcon__+RJYn"};